let cachedWidgetSettings: any = null;

function getInjectedBootstrap() {
  return (window as any).__INCLUWAY_BOOTSTRAP__ ?? null;
}

async function fetchBootstrapFromApi(): Promise<any | null> {
  // optional: if your mount sets this config
  const cfg = (window as any).__INCLUWAY_EMBED__;
  const key = cfg?.key;
  const apiUrl = cfg?.apiUrl ?? "https://api.incluway.de";

  if (!key) return null;

  const url = `${apiUrl.replace(/\/$/, "")}/public/assist/${encodeURIComponent(
    key,
  )}/bootstrap`;

  const res = await fetch(url, { method: "GET", credentials: "omit" });
  if (!res.ok) return null;

  const json = await res.json();
  // depending on backend shape, normalize
  return json?.settings ?? json;
}

export function getWidgetSettings(): Promise<any> {
  return new Promise((resolve) => {
    if (cachedWidgetSettings) return resolve(cachedWidgetSettings);

    // ✅ 1) Direct-mount path: injected bootstrap
    const injected = getInjectedBootstrap();
    if (injected) {
      cachedWidgetSettings = injected;
      return resolve(cachedWidgetSettings);
    }

    // ✅ 2) Direct-mount path: fetch from API if possible
    fetchBootstrapFromApi()
      .then((settings) => {
        if (settings) {
          cachedWidgetSettings = settings;
          resolve(cachedWidgetSettings);
          return;
        }

        // ✅ 3) Legacy fallback: wait for iframe-era message
        function handleMessage(event: MessageEvent) {
          if (event.data?.action === "load-widget") {
            cachedWidgetSettings = event.data?.settings;
            window.removeEventListener("message", handleMessage);
            resolve(cachedWidgetSettings);
          }
        }

        window.addEventListener("message", handleMessage);
      })
      .catch(() => {
        // same legacy fallback on error
        function handleMessage(event: MessageEvent) {
          if (event.data?.action === "load-widget") {
            cachedWidgetSettings = event.data?.settings;
            window.removeEventListener("message", handleMessage);
            resolve(cachedWidgetSettings);
          }
        }
        window.addEventListener("message", handleMessage);
      });
  });
}
